import * as Sentry from "@sentry/react";
import { canShowSentryDevTools, resolveSentryEnvironment } from "@heylife/core";

export function canUseSentryDevTools(): boolean {
  const environment = resolveSentryEnvironment(
    import.meta.env.VITE_APP_ENV,
    import.meta.env.PROD ? "production" : "development",
  );
  return canShowSentryDevTools(environment, import.meta.env.DEV);
}

export function throwSentryVerificationError(): never {
  throw new Error("Sentry verification crash (intentional)");
}

export function captureSentryVerificationMessage(): void {
  Sentry.captureMessage("Sentry verification message (intentional)", "warning");
}
